import React, { useState, useContext } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import DarkTheme from './themes/darkTheme';
import LightTheme from './themes/lightTheme';

type ThemeTypes = 'dark' | 'light';

const CustomThemeContext = React.createContext({
  setTheme: (newTheme: ThemeTypes) => {},
});

const CustomThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState(DarkTheme);

  const context = {
    setTheme: (newTheme: ThemeTypes) => {
      setTheme(newTheme === 'dark' ? DarkTheme : LightTheme);
    },
  };

  return (
    <CustomThemeContext.Provider value={context}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CustomThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(CustomThemeContext);

export default CustomThemeProvider;
